import TrainingQuestions from '../components/TrainingQuestions'
import { validQuestions, coachQuizRequired, quizPassed } from '../trainingQuiz'
import InHouseTraining from '../components/InHouseTraining'
import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import Tabs from "../components/Tabs";
import Editor from "../components/Editor";
import Dropdown from "../components/Dropdown";

const UNCATEGORIZED_COACH_CATEGORY_ID = 'uncategorized-coach-testing'
const UNCATEGORIZED_COACH_CATEGORY = {
    id: UNCATEGORIZED_COACH_CATEGORY_ID,
    name: 'Uncategorised',
    priority: -1,
    isVirtual: true,
}

const normalizeCoachCategoryId = (value = '') => value === UNCATEGORIZED_COACH_CATEGORY_ID ? '' : value

const getCoachCompletedActivityIds = (payload = {}) => {
    const legacyIds = Array.isArray(payload.activities) ? payload.activities : []
    const datedIds = payload.completedActivityDates && typeof payload.completedActivityDates === 'object'
        ? Object.keys(payload.completedActivityDates).filter(Boolean)
        : []

    return [...new Set([...legacyIds, ...datedIds])]
}

const getCoachActivityCompletedAt = (payload = {}, activityId = '') => {
    if (!activityId) {
        return ''
    }

    if (payload.completedActivityDates && typeof payload.completedActivityDates === 'object' && payload.completedActivityDates[activityId]) {
        return payload.completedActivityDates[activityId]
    }

    return payload.updatedAt || ''
}


const Testing = () => {
    const tabs = ['Parents', 'Coaches', 'In-house Training']

    const [isAdding, setIsAdding] = useState(false)
    const [editId, setEditId] = useState('')
    const [name, setName] = useState('')
    const [icon, setIcon] = useState('')
    const [bg, setBg] = useState('')
    const [textColor, setTextColor] = useState('')
    const [priority, setPriority] = useState(1)
    const [audio, setAudio] = useState('')

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [parentsCategories, setParentsCategories] = useState([])
    const [coachCategories, setCoachCategories] = useState([])
    const [coachActivities, setCoachActivities] = useState([])
    const [currentTab, setCurrentTab] = useState(tabs[0])

    const [isAddingCoachCategory, setIsAddingCoachCategory] = useState(false)
    const [coachCategoryEditId, setCoachCategoryEditId] = useState('')
    const [coachCategoryName, setCoachCategoryName] = useState('')
    const [coachCategoryPriority, setCoachCategoryPriority] = useState(1)
    const [selectedCoachCategoryId, setSelectedCoachCategoryId] = useState('')

    const [isAddingCoach, setIsAddingCoach] = useState(false)
    const [coachEditId, setCoachEditId] = useState('')
    const [coachSaving, setCoachSaving] = useState(false)
    const [coachQuestions, setCoachQuestions] = useState([])
    const [coachName, setCoachName] = useState('')
    const [coachExcerpt, setCoachExcerpt] = useState('')
    const [coachPriority, setCoachPriority] = useState(1)
    const [coachAudio, setCoachAudio] = useState('')
    const [coachAudioTitle, setCoachAudioTitle] = useState('')
    const [coachVideo, setCoachVideo] = useState('')
    const [coachPdf, setCoachPdf] = useState('')
    const [coachThumbnail, setCoachThumbnail] = useState('')
    const [coachRelatedLockedActivityId, setCoachRelatedLockedActivityId] = useState('')
    const [coachActivityCategoryId, setCoachActivityCategoryId] = useState('')
    const requiresCoachQuiz = coachQuizRequired(coachCategories.find(c => c.id === coachActivityCategoryId))
    const [confirmDeleteCoach, setConfirmDeleteCoach] = useState(false)
    const [viewingCoachStatsId, setViewingCoachStatsId] = useState('')
    const [viewingCoachStatsName, setViewingCoachStatsName] = useState('')
    const [coachCompletionStats, setCoachCompletionStats] = useState([])

    const userInfo = useSelector(state => state.user.user)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                navigate('/login')
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            fetchCategories()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchCategories = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `testing-categories`), where('type', '==', 'parent'), orderBy('priority', 'desc'))))
        setParentsCategories(docs)

        const coachCategoryDocs = await getFirebaseDocs(await getDocs(query(collection(db, `testing-coach-categories`), orderBy('priority', 'desc'))))
        setCoachCategories(coachCategoryDocs)

        const coachDocs = await getFirebaseDocs(await getDocs(query(collection(db, `testing-coach-activities`), orderBy('priority', 'desc'))))
        setCoachActivities(coachDocs)
    }

    const saveLearnCategory = async () => {
        if (editId) {
            await setDoc(doc(db, 'testing-categories', editId), { name, audio: audio || '', icon, background: bg, textColor, type: 'parent', priority: parseInt(priority) })
        } else {
            await addDoc(collection(db, 'testing-categories'), { name, audio: audio || '', icon, background: bg, textColor, type: 'parent', priority: parseInt(priority) })
        }
        setIsAdding(false)
        setEditId('')
        fetchCategories()
    }

    const resetCoachForm = () => {
        setIsAddingCoach(false)
        setCoachEditId('')
        setCoachName('')
        setCoachQuestions([])
        setCoachExcerpt('')
        setCoachPriority(1)
        setCoachAudio('')
        setCoachAudioTitle('')
        setCoachVideo('')
        setCoachPdf('')
        setCoachThumbnail('')
        setCoachRelatedLockedActivityId('')
        setCoachActivityCategoryId(selectedCoachCategoryId || '')
        setConfirmDeleteCoach(false)
    }

    const resetCoachCategoryForm = () => {
        setIsAddingCoachCategory(false)
        setCoachCategoryEditId('')
        setCoachCategoryName('')
        setCoachCategoryPriority(1)
    }

    const resetCoachStatsView = () => {
        setViewingCoachStatsId('')
        setViewingCoachStatsName('')
        setCoachCompletionStats([])
    }

    const saveCoachActivity = async () => {
        if (requiresCoachQuiz && !validQuestions(coachQuestions)) { toast.error('Add at least one question with 2–4 distinct choices and one correct answer.'); return }
        const payload = {
            name: coachName,
            questions: coachQuestions,
            quizRequired: requiresCoachQuiz,
            audio: coachAudio || '',
            audioTitle: coachAudioTitle || '',
            excerpt: coachExcerpt,
            video: coachVideo,
            pdf: coachPdf || '',
            thumbnail: coachThumbnail,
            priority: parseInt(coachPriority),
            parentId: normalizeCoachCategoryId(coachActivityCategoryId),
            relatedLockedActivityId: coachRelatedLockedActivityId,
        }

        setCoachSaving(true)
        try {
            if (coachEditId) {
                await setDoc(doc(db, 'testing-coach-activities', coachEditId), payload)
            } else {
                await addDoc(collection(db, 'testing-coach-activities'), payload)
            }

            resetCoachForm()
            await fetchCategories()
        } catch { toast.error('Could not save this video. Please try again.') }
        finally { setCoachSaving(false) }
    }

    const editCoachActivity = (activity) => {
        setIsAddingCoach(true)
        setConfirmDeleteCoach(false)
        setCoachEditId(activity.id)
        setCoachName(activity.name || '')
        setCoachQuestions(activity.questions || [])
        setCoachExcerpt(activity.excerpt || '')
        setCoachPriority(activity.priority || 1)
        setCoachAudio(activity.audio || '')
        setCoachAudioTitle(activity.audioTitle || '')
        setCoachVideo(activity.video || '')
        setCoachPdf(activity.pdf || '')
        setCoachThumbnail(activity.thumbnail || '')
        setCoachRelatedLockedActivityId(activity.relatedLockedActivityId || '')
        setCoachActivityCategoryId(activity.parentId || UNCATEGORIZED_COACH_CATEGORY_ID)

    }

    const deleteCoachActivity = async () => {
        if (!coachEditId) {
            return
        }
        if (!confirmDeleteCoach) {
            setConfirmDeleteCoach(true)
            return
        }
        await deleteDoc(doc(db, 'testing-coach-activities', coachEditId))
        resetCoachForm()
        fetchCategories()
    }

    const saveCoachCategory = async () => {
        const payload = {
            name: coachCategoryName,
            quizRequired: coachQuizRequired(coachCategories.find(c => c.id === coachCategoryEditId)) || coachQuizRequired({ name: coachCategoryName }),
            priority: parseInt(coachCategoryPriority),
        }

        if (coachCategoryEditId) {
            await setDoc(doc(db, 'testing-coach-categories', coachCategoryEditId), payload)
        } else {
            await addDoc(collection(db, 'testing-coach-categories'), payload)
        }

        resetCoachCategoryForm()
        fetchCategories()
    }

    const startAddingCoachActivity = (categoryId = '') => {
        setSelectedCoachCategoryId(categoryId)
        resetCoachForm()
        setCoachActivityCategoryId(categoryId || '')
        setIsAddingCoach(true)
    }

    const startManagingCoachCategory = (categoryId = '') => {
        setSelectedCoachCategoryId(categoryId)
        resetCoachCategoryForm()
        resetCoachStatsView()
        resetCoachForm()
    }

    const viewCoachActivityStats = async (activity) => {
        setViewingCoachStatsId(activity.id)
        setViewingCoachStatsName(activity.name || '')

        const [coachUsers, completionDocs] = await Promise.all([
            getFirebaseDocs(await getDocs(query(collection(db, 'users'), where('role', '==', 'coach')))),
            getFirebaseDocs(await getDocs(query(collection(db, 'coach-testing-completed')))),
        ])

        const completedInfo = coachUsers
            .filter(user => {
                const completionRow = completionDocs.find(row => row.userId === user.id)
                return completionRow && getCoachCompletedActivityIds(completionRow).includes(activity.id)
                    && (!coachQuizRequired(coachCategories.find(c => c.id === activity.parentId)) || quizPassed(activity, completionRow.quizResults?.[activity.id]))
            })
            .map(user => {
                const completionRow = completionDocs.find(row => row.userId === user.id)
                return {
                    id: user.id,
                    name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || user.id,
                    email: user.email || '',
                    updatedAt: completionRow ? getCoachActivityCompletedAt(completionRow, activity.id) : ''
                }
            })
            .sort((a, b) => {
                if (a.updatedAt && b.updatedAt && a.updatedAt !== b.updatedAt) {
                    return a.updatedAt > b.updatedAt ? -1 : 1
                }
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
            })

        setCoachCompletionStats(completedInfo)
    }

    const coachCategoryOptions = [
        ...coachCategories.map(({ id, name }) => ({ label: name, value: id })),
        ...(coachActivities.some(activity => !activity.parentId) && !coachCategories.some(category => category.id === UNCATEGORIZED_COACH_CATEGORY_ID) ? [{ label: UNCATEGORIZED_COACH_CATEGORY.name, value: UNCATEGORIZED_COACH_CATEGORY_ID }] : [])
    ]

    const effectiveSelectedCoachCategoryId = selectedCoachCategoryId || coachActivityCategoryId
    const currentCoachCategory = coachCategories.find(category => category.id === selectedCoachCategoryId)
        || (selectedCoachCategoryId === UNCATEGORIZED_COACH_CATEGORY_ID ? UNCATEGORIZED_COACH_CATEGORY : null)

    const coachCategoryRows = (() => {
        const rows = [...coachCategories]
        if (coachActivities.some(activity => !activity.parentId) && !coachCategories.some(category => category.id === UNCATEGORIZED_COACH_CATEGORY_ID)) {
            rows.push(UNCATEGORIZED_COACH_CATEGORY)
        }
        return rows
    })()

    const filteredCoachActivities = coachActivities
        .filter(activity => (activity.parentId || UNCATEGORIZED_COACH_CATEGORY_ID) === selectedCoachCategoryId)
        .sort((a, b) => (b.priority || 0) - (a.priority || 0))

    const coachLockingOptions = coachActivities
        .filter(activity => (activity.parentId || UNCATEGORIZED_COACH_CATEGORY_ID) === (effectiveSelectedCoachCategoryId || selectedCoachCategoryId))
        .filter(activity => coachEditId !== activity.id && activity.priority > coachPriority)
        .map(({ id, name }) => ({ label: name, value: id }))

    return <div className="container">
        <Header />
        <>
            {isAdding && <>
                <h2>Add a Testing Category</h2>
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />

                <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Upload icon</label>
                <MyDropzone storageLocation={`Categories/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={icon} updateImage={(doc) => setIcon(doc)} />

                <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
                <MyDropzone storageLocation={`Categories/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audio} updateImage={(doc) => setAudio(doc)} />

                <Input bold type={'text'} errorMessage={''} errors={[]} name={'bg'} value={bg} setValue={setBg} label={'Background'} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'bg'} value={textColor} setValue={setTextColor} label={'Text Color'} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={priority} setValue={setPriority} label={'Priority'} />

                <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                    <button disabled={!name || !bg || !icon || !textColor || !priority || !parseInt(priority)} onClick={saveLearnCategory}>Save</button>
                    <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                </div>
            </>}

            {!isAdding && <>
                <Tabs tabs={tabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />

                {currentTab === 'In-house Training' ? <InHouseTraining /> : currentTab === 'Parents' ? <>
                    <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId('') }}>+ Add New</button>
                    <h2>Testing Categories</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Icon</th>
                                <th>Background Color</th>
                                <th>Text Color</th>
                                <th>Priority</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {parentsCategories.map(({ id, name, audio, icon, background, priority, textColor }) => <tr key={id}>
                                <td>{name}</td>
                                <td><img alt="" src={icon} style={{ width: '100px', height: '100px' }} /></td>
                                <td>{background}</td>
                                <td>{textColor}</td>
                                <td>{priority}</td>
                                <td>
                                    <div style={{ display: 'flex' }}>
                                        <button className="textButton" onClick={() => navigate(`/testingCategories?category=${id}`)}>View</button>
                                        <button className="textButton" onClick={() => { setIsAdding(true); setPriority(priority); setEditId(id); setName(name); setIcon(icon); setBg(background); setTextColor(textColor); setAudio(audio) }}>Edit</button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </> : <>
                    {isAddingCoachCategory ? <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ marginBottom: '0' }}>{coachCategoryEditId ? 'Edit' : 'Add'} Coach Testing Category</h2>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={resetCoachCategoryForm}>Cancel</button>
                        </div>

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'coachCategoryName'} value={coachCategoryName} setValue={setCoachCategoryName} label={'Name'} />
                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'coachCategoryPriority'} value={coachCategoryPriority} setValue={setCoachCategoryPriority} label={'Priority'} />

                        <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                            <button disabled={!coachCategoryName || !coachCategoryPriority || !parseInt(coachCategoryPriority)} onClick={saveCoachCategory}>Save</button>
                            <button style={{ margin: '20px auto' }} className="textButton" onClick={resetCoachCategoryForm}>Cancel</button>
                        </div>
                    </> : isAddingCoach ? <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ marginBottom: '0' }}>{coachEditId ? 'Edit' : 'Add'} Coach Testing Block</h2>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={resetCoachForm}>Cancel</button>
                        </div>

                        <Dropdown
                            label={'Category'}
                            options={coachCategoryOptions}
                            setValue={v => {
                                setCoachActivityCategoryId(v ? v.value : '')
                                setCoachRelatedLockedActivityId('')
                            }}
                            value={coachCategoryOptions.find(option => option.value === coachActivityCategoryId) || ''}
                            placeholder={'Choose category'}
                            errorFields={[]}
                        />

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'coachName'} value={coachName} setValue={setCoachName} label={'Name'} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Video</label>
                        <MyDropzone allowVideo storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'coachVideo'} image={coachVideo} updateImage={(doc) => setCoachVideo(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Thumbnail</label>
                        <MyDropzone storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'coachThumbnail'} image={coachThumbnail} updateImage={(doc) => setCoachThumbnail(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
                        <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'coachAudio'} image={coachAudio} updateImage={(doc) => setCoachAudio(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio Title</label>
                        <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'coachAudioTitle'} image={coachAudioTitle} updateImage={(doc) => setCoachAudioTitle(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Excerpt</label>
                        <Editor data={coachExcerpt} setData={setCoachExcerpt} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Upload PDF</label>
                        <MyDropzone allowPdf storageLocation={`PDF/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'coachPdf'} image={coachPdf} updateImage={(doc) => setCoachPdf(doc)} />

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'coachPriority'} value={coachPriority} setValue={setCoachPriority} label={'Priority'} />

                        {requiresCoachQuiz ? <><p>Watch at least 90% and answer every question correctly to unlock the next video.</p><TrainingQuestions questions={coachQuestions} onChange={setCoachQuestions} /></> : <p>Coaches complete this video by watching at least 90%. No questions are required.</p>}

                        {requiresCoachQuiz ? <p>Videos unlock in order, highest priority first. Complete each video and its questions before the next one.</p> : <Dropdown
                            label={'Locked until this coach testing block is completed'}
                            options={coachLockingOptions}
                            setValue={v => setCoachRelatedLockedActivityId(v ? v.value : '')}
                            value={coachActivities.find(r => r.id === coachRelatedLockedActivityId) ? ({ label: coachActivities.find(r => r.id === coachRelatedLockedActivityId).name, value: coachActivities.find(r => r.id === coachRelatedLockedActivityId).id }) : ''}
                            placeholder={'Choose activity'}
                            errorFields={[]}
                            clearable
                        />}

                        <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                            <button disabled={coachSaving || !coachName || !coachExcerpt || !coachVideo || !coachPriority || !parseInt(coachPriority)} onClick={saveCoachActivity}>Save</button>
                            <button style={{ margin: '20px auto' }} className="textButton" onClick={resetCoachForm}>Cancel</button>
                            <button disabled={!coachEditId} style={{ backgroundColor: 'red' }} onClick={deleteCoachActivity}>{confirmDeleteCoach ? 'Confirm Delete' : 'Delete'}</button>
                        </div>
                </> : viewingCoachStatsId ? <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h2 style={{ marginBottom: '0' }}>Coach Testing Completion: {viewingCoachStatsName}</h2>
                        <button className="textButton" style={{ marginLeft: 'auto' }} onClick={resetCoachStatsView}>Back</button>
                    </div>

                    <p style={{ marginTop: '10px', fontSize: '14px' }}>
                        {coachCompletionStats.length} coach{coachCompletionStats.length === 1 ? '' : 'es'} completed this testing block.
                    </p>

                    <table>
                        <thead>
                            <tr>
                                <th>Coach</th>
                                <th>Email</th>
                                <th>Last Updated</th>
                            </tr>
                        </thead>
                        <tbody>
                            {coachCompletionStats.map(row => <tr key={row.id}>
                                <td>{row.name}</td>
                                <td>{row.email || '-'}</td>
                                <td>{row.updatedAt ? new Date(row.updatedAt).toLocaleString() : '-'}</td>
                            </tr>)}
                            {coachCompletionStats.length === 0 && <tr>
                                <td colSpan={3}>No coaches have completed this testing block yet.</td>
                            </tr>}
                        </tbody>
                    </table>
                </> : selectedCoachCategoryId ? <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button className="textButton" style={{ marginLeft: '0' }} onClick={() => startManagingCoachCategory('')}>←Back</button>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => startAddingCoachActivity(selectedCoachCategoryId)}>+ Add New</button>
                        </div>

                        <h2>{currentCoachCategory ? currentCoachCategory.name : 'Coach Testing'} Blocks</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Thumbnail</th>
                                    <th>Priority</th>
                                    <th>Unlocks After</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCoachActivities.map((activity) => <tr key={activity.id}>
                                    <td>{activity.name}</td>
                                    <td>{activity.thumbnail ? <img alt="" src={activity.thumbnail} style={{ height: '100px' }} /> : '-'}</td>
                                    <td>{activity.priority}</td>
                                    <td>{(filteredCoachActivities.find(row => row.id === activity.relatedLockedActivityId) || {}).name || 'None'}</td>
                                    <td>
                                        <button className="textButton" onClick={() => viewCoachActivityStats(activity)}>View</button>
                                        <button className="textButton" onClick={() => editCoachActivity(activity)}>Edit</button>
                                    </td>
                                </tr>)}
                                {filteredCoachActivities.length === 0 && <tr>
                                    <td colSpan={6}>No coach testing blocks in this category yet.</td>
                                </tr>}
                            </tbody>
                        </table>
                    </> : <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { resetCoachCategoryForm(); setIsAddingCoachCategory(true) }}>+ Add New</button>
                        </div>

                        <h2>Coach Testing Categories</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Priority</th>
                                    <th>Blocks</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coachCategoryRows.map((category) => <tr key={category.id}>
                                    <td>{category.name}</td>
                                    <td>{category.priority}</td>
                                    <td>{coachActivities.filter(activity => (activity.parentId || UNCATEGORIZED_COACH_CATEGORY_ID) === category.id).length}</td>
                                    <td>
                                        <button className="textButton" onClick={() => startManagingCoachCategory(category.id)}>View</button>
                                        {<button className="textButton" onClick={() => {
                                            setCoachCategoryEditId(category.id)
                                            setCoachCategoryName(category.name || '')
                                            setCoachCategoryPriority(category.isVirtual ? 1 : category.priority || 1)
                                            setIsAddingCoachCategory(true)
                                        }}>Edit</button>}
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </>}
                </>}
            </>}
        </>
    </div>
}

export default Testing
